import { render, staticRenderFns } from "./AssignTableCircuits.vue?vue&type=template&id=1067f2f1&scoped=true&"
import script from "./AssignTableCircuits.vue?vue&type=script&lang=ts&"
export * from "./AssignTableCircuits.vue?vue&type=script&lang=ts&"
import style0 from "./AssignTableCircuits.vue?vue&type=style&index=0&id=1067f2f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1067f2f1",
  null
  
)

export default component.exports